// eszköz-kategória badge — a jel a KÖZÖS badge-katalógusból jön (`domain-badge.tsx`, `assetCategory`
// fogalom): hardware → secondary + monitor-ikon, software → violet + rács-ikon. a kisbetűs felirat a
// `DomainBadge` kényszere, nem ezé a komponensé — így egy jövőbeli hívási hely sem tud nagybetűs badge-et
// csinálni.
import { DomainBadge } from '@/components/shared/domain-badge';

export interface AssetCategoryBadgeProps {
  /** A fő-kategória (hardware | software) — a jel forrása. */
  category: string;
  /** A megjelenített (lokalizált) kategória-címke — a hívó adja `t('assets.categoryLabel.…')`-ból. */
  label: string;
  className?: string;
}

export function AssetCategoryBadge({
  category,
  label,
  className,
}: AssetCategoryBadgeProps): JSX.Element {
  return <DomainBadge kind="assetCategory" value={category} label={label} className={className} />;
}
